import { useEffect, useRef } from 'react'
import { useLocation } from 'wouter'
import { posthog } from '../lib/analytics'

export const usePageTracking = () => {
  const [location] = useLocation()
  const prevLocation = useRef(location)
  const loadStart = useRef(performance.now())

  useEffect(() => {
    if (location !== prevLocation.current) {
      posthog.capture('$pageview', {
        path: location,
        previous_path: prevLocation.current,
      })
      prevLocation.current = location
    }

    const loadTime = Math.round(performance.now() - loadStart.current)
    if (loadTime > 0 && loadTime < 30000) {
      posthog.capture('page_load_time', {
        duration_ms: loadTime,
        route: location,
      })
    }
    loadStart.current = performance.now()
  }, [location])
}
